import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";

const livePulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.55);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(255, 68, 68, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0);
  }
`;

/* The phase chip is the shared WidgetTag; this only anchors the dot to its
   top-right corner, so the tag keeps matching every other widget header. */
export const TagWithDot = styled.span`
  display: inline-flex;
  position: relative;
`;

export const LiveDot = styled.span`
  animation: ${livePulse} 1.8s ease-out infinite;
  background: ${({ theme }) => theme.colors.heartRed ?? "#ff4444"};
  border-radius: 50%;
  height: 7px;
  position: absolute;
  right: -3px;
  top: -3px;
  width: 7px;
`;

export const CompetitionLink = styled(Link)`
  color: inherit;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-decoration: none;
`;

export const Banner = styled.div<{ $src: string }>`
  background-color: ${({ theme }) => theme.colors.navy500};
  background-image: ${({ $src }) => ($src ? `url(${$src})` : "none")};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  height: 96px;
  width: 100%;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 13px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Prize = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.goldStar};
  display: flex;
  font-size: 14px;
  font-weight: 800;
  gap: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Meta = styled.div`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 11.5px;
`;
